import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow
} from "@mui/material";
import React from "react";
import { ViewButtonSingle } from "../ViewButton/ViewButton";
import ProductModal from "../Modals/Product";

export default function ItemDisplay(
	{
		item, 
		itemType, 
		permissions 
	}
) {

	const Allocations = ({allocations}) => {

		if (!allocations || allocations.length === 0) return null;

		// seller-api can return multiple allocation rows per order line (orders.order_item_allocations).
		// Rows with batch_number "" are not user-meaningful batch data:
		//   - Non-batch-tracked SKUs (packaging, inserts) often only have empty batch_number.
		//   - Some warehouses also store a placeholder row (batch_number "") alongside a later row
		//     with the real lot, when despatch sync runs before barcode/lot data is available.
		//
		// Previously we used isPropertyEmpty(allocations, "batch_number"), which only inspected
		// allocations[0]. If that first row was "" but a later row had a lot (BEZ-5563 / Kurk on
		// UK-Norsk), the entire batch sub-table was hidden even though valid batch data existed.
		//
		// We render only rows with a non-empty batch_number so placeholder rows neither block real
		// lots nor appear as blank lines in the batch table.
		const batchAllocations = allocations.filter(
			(allocation) => allocation.batch_number != null && String(allocation.batch_number).trim() !== ""
		);

		if (batchAllocations.length === 0) return null;

		return (
			<TableRow>
				<TableCell colSpan="2"></TableCell>
				<TableCell colSpan="3">
					<Table>
						<TableHead>
							<TableRow>
								<TableCell align="left">Batch Number</TableCell>
								{(itemType === "asn") ?
									<TableCell align="left">Quantity Received</TableCell>
									:
									<TableCell align="left">Quantity Allocated</TableCell>
								}
							</TableRow>
						</TableHead>
						<TableBody>
							{batchAllocations.map((allocation, index) =>
								<TableRow key={`${allocation.batch_number}-${index}`}>
									<TableCell align="left">{allocation.batch_number}</TableCell>
									<TableCell align="left">{allocation.quantity}</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableCell>
			</TableRow>
		);
	};

	const Product = ({ id }) => (
		id ? (
			<TableCell align="right">
				<ProductModal id={id} />
			</TableCell>
		) : null
	);
	
	const DetailLink = ({ id }) => (
		permissions?.has("inventory-detail") && (
			<TableCell align="right">
				<ViewButtonSingle
					buttonTitle={"View Details"}
					buttonLink={"/inventory-detail/"}
					buttonProps={[
						{
							"id": id,
							"components": []
						}
					]}
				/>
			</TableCell>
		)
	);

	if (itemType === "asn") {
		return (
			<>
				<TableRow key={item.sku}>
					<TableCell align="left">{item.sku}</TableCell>
					<TableCell align="left">{item.sku_name}</TableCell>
					<TableCell align="left">{item.units_expected}</TableCell>
					<TableCell align="left">{item.units_received}</TableCell>
				</TableRow>
				<Allocations allocations={item.allocations} />
			</>
		);
	}
	
	if (itemType === "order") {
		return (
			<>
				<TableRow key={item.order_item_id}>
					<TableCell align="left">{item.sku}</TableCell>
					<TableCell align="left">{item.bundle_id}</TableCell>
					<TableCell align="left">{item.name}</TableCell>
					<TableCell align="left">{item.quantity}</TableCell>
					<TableCell align="left">{item.allocated}</TableCell>
					<Product id={item.product_id} />
					<DetailLink id={item.product_id} />
				</TableRow>
				<Allocations allocations={item.allocations} />
			</>
		);
	}

	if (itemType === "bundle") {
		return (
			<TableRow key={item.id}>
				<TableCell align="left">{item.product.sku}</TableCell>
				<TableCell align="left">{item.product.name}</TableCell>
				<TableCell align="left">{item.quantity}</TableCell>
				<Product id={item.product.platform_id} />
				<DetailLink id={item.product.platform_id} />
			</TableRow>
		);
	}

	return null;
}
